<!-- 地区选择弹窗 -->
<template>
  <jd-dialog append-to-body
      title="自定义地区选择"
      :visible="dialogVisible"
      width="1103px"
      @close="handleDialogClose"
      @confirm="closeFn(1)"
      @closeFn="closeFn">
    <!-- <my-popup
      title="自定义地区选择"
      width="1150"
      zIndex="3330"
      :flag="dialogVisible"
      @close="handleDialogClose"
    > -->
    <div class="dialog-content">
      <city-popver-checkbox 
        v-if="isShow"
        @closeFn="closeFn"
        v-bind="$attrs"
        ref="cityPopverCheckbox"></city-popver-checkbox>

    </div>
    <!-- </my-popup> -->
  </jd-dialog>
</template>

<script>
import CityPopverCheckbox from "./city-popover-checkbox-x";
import myPopup from "@/components/myPopup";
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
  },
  components: {
    CityPopverCheckbox,
    myPopup
  },
  data() {
    return {
      dialogVisible: false,
      areaList: [],
      isShow:true
    };
  },

  created() {},

  methods: {
    closeFn(v) {
      if (v === 1) {
        // console.log(this.$refs.cityPopverCheckbox.getResult());
        this.$emit("on-change",this.$refs.cityPopverCheckbox.getResult());
        this.$emit("input", false);
      } else {
        this.$emit("on-change",this.$refs.cityPopverCheckbox.getResult(),'cancel');
        this.$emit("input", false);
      }
    },
    handleDialogClose(value) {
      // console.log(this.$refs.cityPopverCheckbox.getResult());
      this.$emit("on-change",this.$refs.cityPopverCheckbox.getResult(),'cancel');
      // this.$emit("on-change", this.$refs.cityPopverCheckbox.getResult()); // 没有数据也要传值回去,回显判断是否有数据，若无则地区选择为不限
      this.$emit("input", false);
      //this.$emit("input", value);
    }
  },

  watch: {
    value(value) {
      this.dialogVisible = value;
      this.isShow = value
    }
  }
};
</script>
<style lang='scss' scoped>
// .dialog-content{
//   padding-top: 30px;
//   color: #606266;
//   font-size: 14px;
// }
</style>
